/**
 * fileToBase64
 *
 * تبدیل یک فایل (File/Blob) به رشته Base64.
 *
 * این تابع یک Promise برمی‌گرداند که پس از تبدیل موفقیت‌آمیز فایل به Base64
 * مقدار رشته‌ای آن را ارائه می‌دهد. در صورت عدم ارائه فایل یا خطا در خواندن فایل،
 * Promise با خطا reject می‌شود.
 *
 * @param file فایل مورد نظر برای تبدیل (نوع File یا Blob)
 * @returns Promise<string> رشته Base64
 *
 * @example
 * ```ts
 * const fileInput = document.querySelector<HTMLInputElement>("#fileInput");
 * if (fileInput?.files?.[0]) {
 *   fileToBase64(fileInput.files[0])
 *     .then(base64String => console.log(base64String))
 *     .catch(error => console.error(error));
 * }
 * ```
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!file) return reject(new Error("No file provided"));
    if (!(file instanceof Blob)) return reject(new Error("Provided value is not a Blob/File"));

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};
